import React from 'react'
import PropTypes from 'prop-types'

const NavComponent = ({
    nav,
    link,
    colour,
}) => (

    <li>
        <a href={`${link}`} style={{ color: `${colour}` }}>
            {nav}
        </a>
    </li>
)
NavComponent.propTypes = {
    nav: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired,

}

export default NavComponent
